<template>
  <div role="equipment-map" class="equipment-map mt-1 mb-1"></div>
  <dismissable>
    <template v-slot:content>
      <p>OnPoint Software - Patented</p>
    </template>
  </dismissable>
</template>

<script>
import { BDMap } from '../onPoint/onPoint'
import { BDMapConfig } from '../onPoint/config'
import Dismissable from '@/components/Dismissable.vue'

export default {
  emits: ['call-back'],
  mounted () {
    if (this.address) {
      this.initialize()
    }
  },
  data () {
    return {
      bdMap: null
    }
  },
  components: {
    Dismissable
  },
  props: {
    dumpsterType: {
      required: true
    },
    address: {
      required: true
    }
  },
  methods: {
    callback (data) {
      this.$emit('call-back', data)
    },
    initialize () {
      const mapDom = document.querySelector('[role="equipment-map"]')
      mapDom.innerHTML = ''
      this.bdMap = new BDMap(mapDom, BDMapConfig, this.callback)
      if (this.address) {
        this.bdMap.initialize()
          .then(() => this.bdMap.loadAddress(this.address))
          .then(() => this.bdMap.addEquipment(30, 12, this.dumpsterType))// width, height, name
          .then(() => this.bdMap.saveonstart())
          .then(() => this.bdMap.dumpsterDescripton(this.dumpsterType))
      }
    },
    showOverlay () {
      this.bdMap.showOverlay()
    },
    hideOverlay () {
      this.bdMap.hideOverlay()
    }
  }
}
</script>
